export default __webpack_public_path__ + "static/media/CC14_COVID19_Reopening_Support_&_Verification_Visit.98dfbfc0.pdf";